import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import ImgA from "../../assets/images/aaa.png";
import WaitlistForm from "../../component/WaitlistForm";

class Section extends Component {
  constructor() {
    super();
    const experiments = [
      {
        waitlist_version: 1,
        waitlist_name: "askmeanything",
        header:
          "Ever wondered what it's actually like be a YouTuber, software engineer or nurse?",
        subheader:
          "Ask a professional anything about their profession for the cost of a single coffee or beer.",
        CTA: "Notify me when I can start talking to professionals.",
        img: ImgA,
      },
    ];

    const selectedExperiment = experiments[0];
    localStorage.clear();

    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home bg-light" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img">
                        <div className="animation-4"></div>
                      </div>
                      <p className="biz-name mt-4 mb-0">ASK ME ANYTHING</p>
                      <h1 className="home-title mt-4">
                        Ever wondered what it's <i>actually</i> like be a
                        YouTuber, software engineer or nurse?
                      </h1>
                      <p className="text-muted mt-4 f-20">{subheader}</p>
                      <WaitlistForm
                        selectedExperiment={this.state.selectedExperiment}
                      />

                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="animation-1"></div>
                      <div className="animation-2"></div>
                      <div className="animation-3"></div>
                      <div className="hero">
                        <img
                          src={img}
                          style={{ height: "100%", width: "100%" }}
                          className="img-fluid hero-photo"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
